























































import { Component, Vue } from 'vue-property-decorator';
import { Surface, Typography, Picture } from '@/components/atoms';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

@Component({
  components: {
    Surface,
    Typography,
    Picture,
    FilledButton
  }
})
export default class WidgetEmptyState extends Vue {
  providers: any[] = [];

  async openSettingsPage() {
    await this.$ga.event({
      eventCategory: 'loyalt-widget',
      eventAction: 'click',
      eventLabel: 'Take me to Integrations'
    });
    this.$router.push('/settings/apps');
  }

  created() {
    this.initProviders();
  }

  isString(variable: string) {
    return typeof variable === 'string';
  }

  replaceLastOccurrenceInString(
    input: string,
    find: string,
    replaceWith: string
  ) {
    if (
      !this.isString(input) ||
      !this.isString(find) ||
      !this.isString(replaceWith)
    ) {
      return input;
    }

    const lastIndex = input.lastIndexOf(find);
    if (lastIndex < 0) {
      return input;
    }

    return (
      input.substr(0, lastIndex) +
      replaceWith +
      input.substr(lastIndex + find.length)
    );
  }

  get tPrefix() {
    return 'common.components.widgetEmptyState';
  }

  get availables() {
    return this.providers.filter(provider =>
      provider.features.includes('widget')
    );
  }

  get namesProviders() {
    const providersNames = this.availables.map(
      provider => provider.displayName
    );
    const groupText = providersNames.join(', ');
    return this.replaceLastOccurrenceInString(groupText, ',', ' or');
  }

  get getBusinessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  initProviders() {
    this.providers = this.$store.getters[
      'merchant/getActiveProvidersCountryList'
    ];
  }
}
